var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpClient } from '@angular/common/http';
import { BaseService } from "app/views/base.service";
import { DataProvider2, DataProviderFactory } from "../provider/data2.provider";
var UserService = /** @class */ (function (_super) {
    __extends(UserService, _super);
    function UserService(http, dp, dpf) {
        var _this = _super.call(this, http) || this;
        _this.http = http;
        _this.dp = dp;
        _this.dpf = dpf;
        _this.reg_day = _this.dpf.getNew('reg_day');
        _this.activity = _this.dpf.getNew('activity');
        _this.userLive = _this.dpf.getNew('user/live');
        _this.userCharts = _this.dpf.getNew('user_charts');
        return _this;
    }
    UserService.prototype.getProviderList = function () {
        return this.dp.get('/user/provider');
    };
    UserService.prototype.addProvider = function (newProvider) {
        return this.dp.post('/user/provider', newProvider);
    };
    UserService.prototype.editProvider = function (provider) {
        return this.dp.put("/user/provider/" + provider._id, provider);
    };
    UserService.prototype.deleteProvider = function (provider) {
        return this.dp.delete("/user/provider/" + provider._id);
    };
    UserService.prototype.getRoleList = function () {
        return this.dp.get('/user/role');
    };
    UserService.prototype.addRole = function (newRole) {
        return this.dp.post('/user/role', newRole);
    };
    UserService.prototype.editRole = function (role) {
        return this.dp.put("/user/role/" + role._id, role);
    };
    UserService.prototype.deleteRole = function (role) {
        return this.dp.delete("/user/role/" + role._id);
    };
    return UserService;
}(BaseService));
export { UserService };
